import request from '@/http/request'
import {
    getSignNumber,
    getRealTimePay,
    getScoreDistribution,
    judgeIsViewPay,
    getSmartReminder
} from '@/http/api'

export const getSmartReminderAPI = (data) => {
    return request({
        url: getSmartReminder,
        data
    })
}

export const getSignNumberFn = () => {
    return request({
        url: getSignNumber,
    })
}

export const judgeIsPay = () => {
    return request({
        url: judgeIsViewPay,
    })
}

export const getRealTimePayFn = () => {
    return request({
        url: getRealTimePay,
    })
}

export const scoreData = (data) => {
    return request({
        url: getScoreDistribution,
        data
    })
}